// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26n4W","col":"styles_col__mRqoL"};